import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/images/check_done_white.png'


const _hoisted_1 = { class: "flow-block-wrapper" }
const _hoisted_2 = { class: "flow-block" }
const _hoisted_3 = { class: "flow-circles" }
const _hoisted_4 = { class: "flow-circle-top" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "checked-img",
  src: _imports_0
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.circleTextArray, (singleCircle, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(["circle", [_ctx.circleClass(index)]]),
                onClick: ($event: any) => (_ctx.toggleCircle(index))
              }, _hoisted_7, 10, _hoisted_5),
              (index !== _ctx.circleTextArray.length - 1)
                ? (_openBlock(), _createElementBlock("hr", {
                    key: 0,
                    class: _normalizeClass([{
                'filled-path':
                  _ctx.selectedCircleArray.includes(index + 1) ||
                  _ctx.selected === index + 1,
              }, "dashed-path"])
                  }, null, 2))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["circle-text small-text-grey", `text-${_ctx.circleClass(index)}`])
            }, _toDisplayString(_ctx.$t(singleCircle)), 3)
          ]))
        }), 128))
      ])
    ])
  ]))
}